import React from 'react';
import { Check } from 'lucide-react';
interface IncludedListProps {
  eyebrow: string;
  heading: string;
  intro?: string;
  items: {
    title: string;
    body: string;
  }[];
}
export function IncludedList({
  eyebrow,
  heading,
  intro,
  items
}: IncludedListProps) {
  return <section className="px-5 md:px-6 py-20 md:py-28 bg-surface" data-id="element-525">
      <div className="max-w-7xl mx-auto" data-id="element-526">
        <div className="max-w-2xl mb-12" data-id="element-527">
          <p className="font-script text-2xl text-accent mb-1" data-id="element-528">{eyebrow}</p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight" data-id="element-529">
            {heading}
          </h2>
          {intro && <p className="mt-4 text-lg text-muted-ink leading-relaxed" data-id="element-530">
              {intro}
            </p>}
        </div>
        <div className="grid sm:grid-cols-2 gap-5" data-id="element-531">
          {items.map(item => <div key={item.title} className="h-full rounded-2xl bg-background border border-border p-6 shadow-card" data-id="element-532">
              <div className="flex items-start gap-4" data-id="element-533">
                <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full bg-accent-soft text-accent" data-id="element-534">
                  <Check className="w-5 h-5" data-id="element-535" />
                </span>
                <div data-id="element-536">
                  <h3 className="font-serif text-xl text-ink" data-id="element-537">{item.title}</h3>
                  <p className="mt-1 text-muted-ink leading-relaxed" data-id="element-538">
                    {item.body}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}